export const statusList = [
    {value: 'ABERTO', label: 'Aberto'},
    {value: 'FINALIZADO', label: 'Finalizado'},
    {value: 'SUSPENSO', label: 'Suspenso'},
]